/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  NutritionAndDietResponseDto,
  NutritionAndDietUpsertRequestDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    NutritionAndDietResponseDtoFromJSON,
    NutritionAndDietResponseDtoToJSON,
    NutritionAndDietUpsertRequestDtoFromJSON,
    NutritionAndDietUpsertRequestDtoToJSON,
} from '../models/index';

export interface GetNutritionAndDietByPatientIdRequest {
    patientId: string;
}

export interface UpsertNutritionAndDietRequest {
    nutritionAndDietUpsertRequestDto: NutritionAndDietUpsertRequestDto;
}

export interface UpsertNutritionAndDietByPatientIdRequest {
    patientId: string;
    nutritionAndDietUpsertRequestDto: NutritionAndDietUpsertRequestDto;
}

/**
 * 
 */
export class PatientNutritionApi extends runtime.BaseAPI {

    /**
     * Get patient\'s nutrition and diet information
     */
    async getNutritionAndDietRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NutritionAndDietResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/nutrition-diets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NutritionAndDietResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s nutrition and diet information
     */
    async getNutritionAndDiet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NutritionAndDietResponseDto> {
        const response = await this.getNutritionAndDietRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get patient\'s nutrition and diet information by patient ID
     */
    async getNutritionAndDietByPatientIdRaw(requestParameters: GetNutritionAndDietByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NutritionAndDietResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getNutritionAndDietByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/nutrition-diets/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NutritionAndDietResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s nutrition and diet information by patient ID
     */
    async getNutritionAndDietByPatientId(requestParameters: GetNutritionAndDietByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NutritionAndDietResponseDto> {
        const response = await this.getNutritionAndDietByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create patient\'s nutrition and diet information
     */
    async upsertNutritionAndDietRaw(requestParameters: UpsertNutritionAndDietRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NutritionAndDietResponseDto>> {
        if (requestParameters['nutritionAndDietUpsertRequestDto'] == null) {
            throw new runtime.RequiredError(
                'nutritionAndDietUpsertRequestDto',
                'Required parameter "nutritionAndDietUpsertRequestDto" was null or undefined when calling upsertNutritionAndDiet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/nutrition-diets`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: NutritionAndDietUpsertRequestDtoToJSON(requestParameters['nutritionAndDietUpsertRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NutritionAndDietResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create patient\'s nutrition and diet information
     */
    async upsertNutritionAndDiet(requestParameters: UpsertNutritionAndDietRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NutritionAndDietResponseDto> {
        const response = await this.upsertNutritionAndDietRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update patient\'s nutrition and diet information by patient ID
     */
    async upsertNutritionAndDietByPatientIdRaw(requestParameters: UpsertNutritionAndDietByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NutritionAndDietResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling upsertNutritionAndDietByPatientId().'
            );
        }

        if (requestParameters['nutritionAndDietUpsertRequestDto'] == null) {
            throw new runtime.RequiredError(
                'nutritionAndDietUpsertRequestDto',
                'Required parameter "nutritionAndDietUpsertRequestDto" was null or undefined when calling upsertNutritionAndDietByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/nutrition-diets/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: NutritionAndDietUpsertRequestDtoToJSON(requestParameters['nutritionAndDietUpsertRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NutritionAndDietResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update patient\'s nutrition and diet information by patient ID
     */
    async upsertNutritionAndDietByPatientId(requestParameters: UpsertNutritionAndDietByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NutritionAndDietResponseDto> {
        const response = await this.upsertNutritionAndDietByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
